import styled from "styled-components";
import COLORS from "../../Theme/Colors";

export const Button = styled.button`
  background-color: ${COLORS.blue};
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #fff;
  padding: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 48px;
  right: 20px;
  z-index: 111;
`;
